<app-resources-section [resources]="collection.resources" [start]="0" [stop]="currentIndex">
</app-resources-section>
<div class="buttons">
    <app-button
        class="see-more"
        buttonClasses="gtm-collection-see-more-resources selenium-collection-see-more-resources"
        [gtmLabel]="collection.title"
        (click)="!collection.isLoadingResources && seeMore()"
        *ngIf="canSeeMore()"
        [disable]="collection.isLoadingResources"
    >
        <span>See More</span>
    </app-button>
    <app-button
        class="see-less"
        buttonClasses="gtm-collection-collapse-resources selenium-collection-collapse-resources"
        [gtmLabel]="collection.title"
        (click)="!collection.isLoadingResources && seeLess()"
        *ngIf="canSeeLess()"
        [disable]="collection.isLoadingResources"
    >
        <span>Collapse</span>
    </app-button>
</div>
